import { render, staticRenderFns } from "./PopsManageDocumentClinic.vue?vue&type=template&id=6f6f60b6"
import script from "./PopsManageDocumentClinic.vue?vue&type=script&lang=js"
export * from "./PopsManageDocumentClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports